module.exports = __webpack_public_path__ + "static/img/14.4d98cfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/page/Music/GoodsShow/AirPods Pro/imgs/first/14.jpg
// module id = NdVW
// module chunks = 0